import { format, parseISO } from "date-fns";
import { Locale } from "date-fns";
import { InvoiceStatementRow } from "./types";

export const parseStatementEmails = (value: string): string[] => {
  const seen = new Set<string>();
  return value
    .split(/[,;\r\n]+/)
    .map((email) => email.trim())
    .filter((email) => {
      const key = email.toLowerCase();
      if (!email || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};

export const formatStatusColor = (color?: string | null): string => {
  if (!color) return "100,116,139";
  if (color.startsWith("#")) {
    const hex = color.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16) || 0;
    const g = parseInt(hex.substring(2, 4), 16) || 0;
    const b = parseInt(hex.substring(4, 6), 16) || 0;
    return `${r},${g},${b}`;
  }
  return color;
};

export const formatStatementDate = (dateStr?: string | null, locale?: Locale): string => {
  if (!dateStr) return "—";
  try {
    return format(parseISO(dateStr), "MMM d, yyyy", locale ? { locale } : undefined);
  } catch {
    return dateStr;
  }
};

export const getInvoiceUrl = (inv: InvoiceStatementRow): string => {
  if (inv.hosted_invoice_url) return inv.hosted_invoice_url;
  const origin =
    typeof window !== "undefined" && window.location?.origin
      ? window.location.origin
      : "";
  return `${origin}/invoices/${inv.id}`;
};

export const extractCompanyDetails = (
  companySettingsQueryData: any,
  fallbackBusinessName?: string
) => {
  const companyLogo = companySettingsQueryData?.companyLogo;
  const companyDetails = companySettingsQueryData?.companySettings;
  const companyName = companyDetails?.name || fallbackBusinessName || "ESERV";
  const companyAddress = companyDetails?.address;
  const companyCityStateZip =
    [companyDetails?.city, companyDetails?.state].filter(Boolean).join(", ") +
    (companyDetails?.zipcode ? ` ${companyDetails.zipcode}` : "");
  const companyPhone = companyDetails?.phone;
  const companyEmail = companyDetails?.email;

  return {
    companyLogo,
    companyDetails,
    companyName,
    companyAddress,
    companyCityStateZip,
    companyPhone,
    companyEmail,
  };
};
